module.exports = __webpack_public_path__ + "static/scale-model-of-wave-field-in-ann-arbor-michigan-627f47ea0b41567b51b20cc9ee69b21a.png";